import {useState, useEffect, useCallback} from 'react'
import {Route, Routes, BrowserRouter} from 'react-router';
import './App.css';
import {base} from './components/Config/app'
import Home from './components/Home/Home';
import Header from './components/Home/Header';
import Footer from './components/Home/Footer';
import {Player} from './components/Shared/ViewAudio';
import Settings from './components/Setting/Settings';
import Sentences from './components/Sentence/Sentences';
import Pages from './components/Page/Pages';
import {ProfileItems} from './components/Profile/Profile'
import {Read} from './components/Shared/Api';

function App() {
  const [etat, Etat]  = useState("")
  const [account, Account] = useState({Service: base.name, connected:false, message:'', roles:'', Id:0, Role:0, Session:0, App:0, Name:'', Email:'', Phone:'', API_KEY:''})

  const [layout, Layout] = useState(window.matchMedia('(orientation:landscape)').matches)
  const [search, Search]  = useState("")
  const [lang, Lang] = useState("en")
  const [items, Items]= useState([])

  useEffect(() => {
    const store = localStorage.getItem(base.name)
    if(store) {
      //alert(`store=${JSON.stringify(store)}`)
      let infos = JSON.parse(store)
      if(infos.connected) {
        //console.info(infos); alert(`infos=${JSON.stringify(infos)}`)
        account.roles = infos.roles
        account.message = infos.message
        Account({...account, connected:true})

        Etat(infos.message)
        //alert(`infos=${JSON.stringify(account)}`)
      }
      else {
        Etat(`${infos.message??'Not Connected'} ?`)
      }
    }
  },[])

  useEffect(() => {
    if(account.connected) {
        //alert(`account connected=${JSON.stringify(account)}`)
        Read(`/member/Profile/1`, Items)
    }
  },[account.connected])

  useEffect(()=>{
    document.documentElement.setAttribute('dir', lang==='ar'?'rtl':'ltr');
  },[lang])

  const getProfile = (key) => {
    // alert(`infos=${JSON.stringify(account)}`)
    return items.find(item => item.Key === key)?.Value ?? ''
  }

  useEffect(()=>{ 
    if(items?.length>0) {
      //alert(JSON.stringify(items))   
      Account({...account, Id:items[0].Id, Name:getProfile('Name'), Email:getProfile('Email'), API_KEY:getProfile('API_KEY') })
    }
  },[items])

  const onResize = useCallback(event => {
    let value = window.matchMedia('(orientation:landscape)').matches    
    Layout(value)
  }, [])

  useEffect(() => {
          window.addEventListener("resize", onResize);
          return () => {
              window.removeEventListener("resize", onResize);
          };
  }, [onResize, layout])


  return (

<BrowserRouter>

  <Header lang={lang} onLang={Lang} onSearch={Search} account={account} />
  
  { account?.connected ?
    <Routes className='App'>    
        <Route path='/' element={ <Home lang={lang} account={account} search={search} service={base.service} onEtat={Etat} /> } exact />
        <Route path='/sentence' element={ <Sentences props={{connected:account.connected, search, layout}} />} />
        <Route path='/page' element={ <Pages search={search} connected={account.connected} Etat={Etat} />} />
        <Route path='/setting' element={ <Settings account={account} search={search} layout={layout}/>} />
        <Route path='/audio' element={ <Player connected={account.connected} />} />
        <Route path='/profile' element={<ProfileItems lang={lang} member={account.Id} onEtat={Etat} />} />
    </Routes>
  :      
    <Home lang={lang} account={account} search={search} service={base.service} onEtat={Etat} />
  }
  <Footer lang={lang} etat={etat} />

</BrowserRouter>

  )

}

export default App;
